/* @flow */

import React from 'react';
import { Redirect } from 'react-router-dom';

import { allRoles } from 'permissions/general';
import Contract from 'views/Contracts/Contract';
import ContractsReportView from 'tables/ContractsReportView/ContractsReportView';
import { formulateUri } from 'tables/components/ReportView/state';

import { filterTradingAccountItem } from './utils/filters';

export const SORT_FIELD_PARAM = 'sortBy';
export const SORT_DIRECTION_PARAM = 'sortDir';
export const FILTERS_PARAM = 'filters';

const contractRoutes: Array<*> = [
  {
    path: '/orders',
    title: 'general:document_titles.contracts.title',
    component: ContractsReportView,
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/orders/:id',
    title: 'general:document_titles.contracts.detail',
    title_keys: ['contract.contract_number', 'contract.status'],
    component: Contract,
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/orders/:id/:actionType',
    title: 'general:document_titles.contracts.action_type',
    title_keys: ['contract.contract_number', 'contract.status', 'currentActionDrawer'],
    component: Contract,
    exact: true,
    permissions: allRoles,
  },
  {
    path: '/orders/account/:accountId',
    component: function AccountContractsTable(props: *) {
      // TODO: Remove this mapping, and navigate to the correct URL at source of navigation
      const searchParams = new URLSearchParams(props.location.search);
      const sortBy = searchParams.get(SORT_FIELD_PARAM);
      const sortDirection = searchParams.get(SORT_DIRECTION_PARAM);
      const filters = searchParams.get(FILTERS_PARAM);
      let initialSort: void | { columnName: string, direction: 'ASC' | 'DESC' };
      let defaultFilters;

      if (filters) {
        try {
          defaultFilters = JSON.parse(decodeURIComponent(filters));
        } catch (error) {}
      }

      if (sortBy) {
        initialSort = { columnName: sortBy, direction: 'ASC' };

        if (['ASC', 'DESC'].includes(sortDirection)) {
          initialSort.direction = sortDirection;
        }
      }

      return (
        <Redirect
          to={formulateUri('/orders', {
            page: 1,
            filters: [
              ...filterTradingAccountItem({
                key: 'account',
                values: [props.match.params.accountId],
              }),
            ],
            sort: initialSort,
          })}
        />
      );
    },
    exact: true,
    permissions: allRoles,
  },
];

export default contractRoutes.map(item => ({
  ...item,
  store: ['contractStore', 'actionDrawerStore'],
}));
